'use client';

import { usePathname } from 'next/navigation';
import { ReactNode, useEffect, useState } from 'react';

import Footer from '@/components/footer';
import Header from '@/components/header';
import MainLayout from '@/components/main-layout';
import ReserveBannerWrapper from '@/components/reserve-banner-wrapper';
import SideCTA from '@/components/side-cta';
import { Toaster } from '@/components/ui/sonner';

interface ConditionalLayoutProps {
  children: ReactNode;
}

export default function ConditionalLayout({
  children,
}: ConditionalLayoutProps) {
  const pathname = usePathname();
  const [isAppLinkRoute, setIsAppLinkRoute] = useState(false);

  useEffect(() => {
    setIsAppLinkRoute(pathname.startsWith('/applink'));
  }, [pathname]);

  if (isAppLinkRoute) {
    // applink 경로는 독립적인 레이아웃 사용
    return <>{children}</>;
  }

  // 일반 경로는 기본 레이아웃 사용
  return (
    <>
      <MainLayout>
        <Header />
        <div className="desktop:px-0 desktop:pb-30 px-6 pb-15">{children}</div>
        <Footer />
        <Toaster
          theme="system"
          position="top-center"
          duration={3000}
          toastOptions={{
            className:
              'bg-black text-white rounded-xl shadow-lg [&>div]:text-white [&>div>div]:text-white [&_[data-description]]:text-white [&_[data-description]]:opacity-90',
            style: {
              background: '#111111',
              color: '#ffffff',
            },
          }}
        />
        <ReserveBannerWrapper />
        <SideCTA />
      </MainLayout>
    </>
  );
}
